// extracted by mini-css-extract-plugin
export default {"succ_d":"Success_succ_d__lUEN1","succ":"Success_succ__lhpmu","succ_l":"Success_succ_l__-lW-u"};